export default {"src":"/_next/static/media/WhoWeAre_050A.4fec2c46.JPG","height":690,"width":1920};